import React from "react";
import { Typography } from "@material-ui/core";
import TableLink from "../TableLink";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
    overflowX: "auto",
    margin: "auto"
  }
});

function RecordList({ classes }) {
  return (
    <div className={classes.root}>
      <Typography variant="body1" gutterBottom>
        <TableLink to={`/record/individual-game`}>
          Best Individual Game Performances
        </TableLink>
      </Typography>
      <Typography variant="body1" gutterBottom>
        <TableLink to={`/record/individual-tournament`}>
          Best Individual Tournament Performances
        </TableLink>
      </Typography>
      <Typography variant="body1" gutterBottom>
        <TableLink to={`/record/individual-career`}>
          Most Individual Career Points
        </TableLink>
      </Typography>
      <Typography variant="body1" gutterBottom>
        <TableLink to={`/record/team-game`}>
          Best Team Game Performances
        </TableLink>
      </Typography>
      <Typography variant="body1" gutterBottom>
        <TableLink to={`/record/team-tournament`}>
          Best Team Tournament Performances
        </TableLink>
      </Typography>
      <Typography variant="body1" gutterBottom>
        <TableLink to={`/record/school`}>Most School Points</TableLink>
      </Typography>
    </div>
  );
}

export default withStyles(styles)(RecordList);
